
enum tabs { Food, Drinks };//, Promotions, Misc };
export default tabs;